import { QUESTION_TYPE } from '../../Activity/Question';
import SmallMarkdown from '../../Markdown/SmallMarkdown';

export default function Answer({
  md,
  questionType,
}: {
  md: string;
  questionType?: QUESTION_TYPE;
}) {
  if (questionType === QUESTION_TYPE.PYTHON_PLAYGROUND) {
    return <SmallMarkdown md={`\`\`\`python\n${md}\n\`\`\``} />;
  }

  if (questionType === QUESTION_TYPE.SQL_PLAYGROUND) {
    return <SmallMarkdown md={`\`\`\`sql\n${md}\n\`\`\``} />;
  }

  return <SmallMarkdown md={md} />;
}
